import {STATUS_LOADING} from "../const";

export default {
    services: state => state.items,
    total: state => Number.parseInt(state.total),
    isLoading: state => state.status === STATUS_LOADING,
    isSaving: state => state.saving,
}
